import Navbar from "components/MI/Navbar";
import React, { useMemo } from "react";
import UserMenu from "components/layout/userMenuNew";
import queryString from "query-string";
import { AiOutlineFileSearch } from "react-icons/ai";
import { BiRightArrowAlt } from "react-icons/bi";
import { useLocation } from "react-router-dom";

import listSearchTag from "./listSearchTag";

import {
  Container,
  Content,
  ContentFirst,
  ContentItem,
  ContentTitle,
  Title,
} from "./styles";

const Pesquisar = (): JSX.Element => {
  const location = useLocation();

  const searchResult = useMemo(() => {
    const search = queryString.parse(location.search)?.search as string;
    const searchSplit = search
      ?.normalize("NFD")
      ?.replace(/[^a-zA-Z\s]/g, "")
      ?.toLocaleLowerCase()
      ?.split(" ");

    const result = listSearchTag?.reduce((previousValue, currentValue): any => {
      let isResultCorrect = false;
      searchSplit?.map((v) => {
        currentValue?.tag?.map((b) => {
          if (v?.includes(b) || b?.includes(v)) {
            b.includes(v);
            isResultCorrect = true;
          }

          return b;
        });

        return v;
      });

      if (isResultCorrect) {
        previousValue?.push(currentValue?.result);
      }

      return previousValue;
    }, [] as any);

    return result;
  }, [location]);

  const search = useMemo(() => {
    return queryString.parse(location.search)?.search;
  }, [location]);

  return (
    <Navbar selected="pesquisar">
      <UserMenu />
      <Container>
        <Title>Pesquisa</Title>
        {searchResult?.length ? (
          <p>
            Resultado da busca por <strong>{search}</strong>
          </p>
        ) : (
          <p>
            Nenhum item foi encontrado na busca por <strong>{search}</strong>
          </p>
        )}

        {searchResult?.length ? (
          <Content>
            {searchResult?.map((a) => (
              <ContentItem key={a?.key} to={a?.url} target={a?.target}>
                <ContentFirst>
                  <AiOutlineFileSearch />
                  <ContentTitle>{a?.title}</ContentTitle>
                </ContentFirst>
                <BiRightArrowAlt />
              </ContentItem>
            ))}
          </Content>
        ) : null}
      </Container>
    </Navbar>
  );
};

export default Pesquisar;
